import { Stack, Typography } from "@mui/material";

export default function RecommendationCell({ recomendation }) {
  if (!recomendation || recomendation === " ") return "-";
  return (
    <Stack
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        width: "100%",
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color: "#000000DE",
          fontSize: "14px",
          fontWeight: 400,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          width: "100%",
        }}
      >
        {recomendation}
      </Typography>
    </Stack>
  );
}
